import { Application } from '@hotwired/stimulus'

import PostController from '../post_controllers/post_controller'

import 'highlight.js/styles/base16/dracula.css'

const application = Application.start()

application.register('post', PostController)
